import { Button } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Languages from '../../components/Languages'
import Logo from '../../components/Logo';
import { logoutUser } from '../../redux/slices/authSlice';

function Header() {
    
    const navigate = useNavigate();
    const dispatch = useDispatch();


    const handleLogout = () => {
        dispatch(logoutUser());
        navigate("/prelogin");
    }

    return (
        <div className='prehead'>
            <div>
                <Logo width={'120'} height={'100'}/>
            </div>
            <div style={{display:'flex', alignItems:'center'}}>
                <Languages />
                <Button sx={{ width:100}}  variant="contained" className='btn'  onClick={handleLogout}>Logout</Button>
            </div>
        </div>
    )
}

export default Header